import Cookies from "js-cookie";
import { Navigate, Outlet } from "react-router-dom";
import { loginMethods } from "./Components/CashAllocation/constants";
import ROUTES from "./utils/routes";
import { useDispatch, useSelector } from "react-redux";

const InlineStyles = {
  Container: {
    display: "flex",
    margin: 8,
    width: "calc(100vw - 16px)",
    height: "calc(100vh - 142px)",
    borderRadius: 8,
    gap: 16,
    boxShadow: "0px 4px 20px 0px #00000029",
    backgroundColor: "#FFFFFF",
  },
};

const PublicRoutes = () => {
  const { isLoggedIn, loginError, isLoading } = useSelector((state) => state?.login);

  return isLoggedIn ? (
    <Navigate
      to={ROUTES.MUSU}
      replace
    />
  ) : (
    <Outlet />
  );
};

export default PublicRoutes;
